import axios from 'axios';
import {configApi} from '../../api/configApi';
import {router} from '../../main.js';
import {headers} from '../../api/headers';
import {store} from '../index';

export default {
  namespaced: true,
  state: {
       tribunas: [],
       tribuna: null,
       pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 0,
          sortBy: '',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pages: 0,
    loading: false,
  },
  getters: {
    listTribunas: (state,getters,rootState) => {
          return state.tribunas;
    },
    tribuna: (state,getters,rootState) => {
        return state.tribuna;
    },
    pagination(state,getters,rootState){
      return state.pagination;
    },
    pages(state,getters,rootState){
      return state.pages;
    },
    totalItemCount(state,getters,rootState){
        return state.pagination.totalItems;
    },
    loading(state,getters,rootState){
        return state.loading;
    },
  },
  mutations: {
        listTribunas: (state,tribunas) => {
          state.tribunas = tribunas;
          state.pagination.totalItems = tribunas.total;
          state.pagination.page = tribunas.current_page;
          state.pagination.rowsPerPage = tribunas.per_page;
       },
      listTribunasSearch: (state,tribunas) => {
            if(tribunas != null){ 
                state.tribunas = tribunas;
            }else{
              state.tribunas = null;
            }
       },
      viewTribuna(state,id){
        let auxTribuna = state.tribunas.filter((item) => item.id == id);
        state.tribuna = auxTribuna[0];
      },
      setTribuna(state,tribuna){
          state.tribuna = tribuna;
      },
    pages(state){
         if (state.pagination.rowsPerPage == null ||
              state.pagination.totalItems == null) { 
              state.pages = 0;
          } 

        state.pages = Math.ceil(state.pagination.totalItems / state.pagination.rowsPerPage);
    },
  },
  actions: {
    listTribunas({state,getters,commit,rootState}){
      state.loading = true;
      axios.get(`${configApi.apiUrl}tribuna_all`,null,{headers: headers})
      .then(response => {
        //console.log(response.data.data.data);
        commit('listTribunas',response.data.data);
        commit('pages');
        state.loading = false;
      })
      .catch(error => {
        state.loading = false;
        swal("Error!", "Error al obtener las tribunas!", "error");
        console.error(error);
      });

    },
  newTribuna({state,getters,commit,rootState},payload){
      // nombre
      // id_auditorio
      store.commit('changeLoader', true);
      store.dispatch('validateToken');
      return axios.post(`${configApi.apiUrl}tribuna`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se creo la tribuna correctamente!", "success");
        store.dispatch('tribuna/listTribunas',state.pagination.page);
        commit('setTribuna',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        swal("Error!", "Error al crear la tribuna!", "error");
        console.error(error);
        store.commit('changeLoader', false);
      });
  },
  updateTribuna({state,getters,commit,rootState},payload){
      // nombre
      // id_auditorio
      store.dispatch('validateToken');
      axios.put(`${configApi.apiUrl}tribuna/${payload.id}`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se actualizo la tribuna correctamente!", "success");
        store.dispatch('tribuna/listTribunas',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al actualizar la tribuna!", "error");
        console.error(error);
      });
  },
  deleteTribuna({state,getters,commit,rootState},tribuna){
    store.dispatch('validateToken');
    axios.delete(`${configApi.apiUrl}tribuna/${tribuna}`,null,{headers: headers})
     .then(response => {
        swal("Exito!", "Se elimino la tribuna correctamente!", "success");
        store.dispatch('tribuna/listTribunas',state.pagination.page);
     })
     .catch(error => {
        swal("Error!","Error al eliminar la tribuna!","error");
        //console.log(error);
     });
  },
    searchTribunas({state,getters,commit,rootState},key){
      store.dispatch('validateToken');
      store.commit('changeLoader', true);
      axios.get(`${configApi.apiUrl}buscarTribuna?nombre=${key}`,null,{headers: headers})
      .then(response => {
        commit('listTribunasSearch',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        store.commit('changeLoader', false);
        swal("Error!", "Error al obtener las tribunas!", "error");
        console.error(error);
      });

    },
  },
}